// extracted by mini-css-extract-plugin
export default {"table-container":"connectionTable_table-container__7-yFY","table-button":"connectionTable_table-button__TlQQh","overlay":"connectionTable_overlay__GK4Vh"};